
import Component from '../../../assets/scripts/modules/component'

class DonationRowComponent extends Component {
  init () {
    this.buttons = [...this.element.querySelectorAll('.button[data-option]')]
    this.input = this.element.querySelector('input')

    if (!this.buttons.length || !this.input) {
      return
    }

    this.buttons.forEach(button => button.addEventListener('click', () => {
      this.input.value = parseInt(button.getAttribute('data-option'), 10)
      this.input.dispatchEvent(new Event('change'))
    }))
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.donation-row').forEach(element => {
  element.instance = element.instance || new DonationRowComponent(element)
}))
